import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-job-signoff-workshop',
    templateUrl: './job-signoff-workshop.component.html',
    styleUrls: ['./job-signoff-workshop.component.scss'],
    standalone: false
})
export class JobSignoffWorkshopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
